import ApiClient from './apiClient';
import { User } from './authService';

export interface ProfileUpdateData {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  use_for?: string;
  language?: string;
  company?: string;
  role?: string;
  country?: string;
  state?: string;
  city?: string;
  street?: string;
  house_no?: string;
  zip_code?: string;
  
  // New location API fields
  country_id?: number | null;
  state_id?: number | null;
  city_id?: number | null;
  city_other?: string;
  
  // Signature and letterhead fields
  signature?: string;
  letterhead?: string;
}

export interface PasswordUpdateData {
  current_password: string;
  password: string;
  password_confirmation: string;
}

export interface ProfileResponse {
  user: User;
  message: string;
}

const profileService = {
  updateProfile: async (data: ProfileUpdateData): Promise<ProfileResponse> => {
    return ApiClient.patch<ProfileResponse, ProfileUpdateData>('/profile', data);
  },

  updatePassword: async (data: PasswordUpdateData): Promise<{ message: string }> => {
    return ApiClient.patch<{ message: string }, PasswordUpdateData>('/profile/password', data);
  },

  updateSignature: async (signature: string): Promise<ProfileResponse> => {
    return ApiClient.patch<ProfileResponse, { signature: string }>('/profile', { signature });
  },

  updateLetterhead: async (letterhead: string): Promise<ProfileResponse> => {
    return ApiClient.patch<ProfileResponse, { letterhead: string }>('/profile', { letterhead });
  },

  updateSignatureAndLetterhead: async (signature?: string, letterhead?: string): Promise<ProfileResponse> => {
    const data: { signature?: string; letterhead?: string } = {};
    if (signature) data.signature = signature;
    if (letterhead) data.letterhead = letterhead;
    return ApiClient.patch<ProfileResponse, typeof data>('/profile', data);
  },
};

export default profileService; 